import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PostingList from "./PostingList";
import TrendingGames from "./TrendingGames";
import gamesData from "./gamesData";
import { t } from "../i18n";
import styles from "./TrendingGames.module.css";
import filterStyles from "./FilterSearch.module.css";
import "./Posts.css";
import { useNavigate } from "react-router-dom";

const FilterSearch = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const query = queryParams.get("query")?.toLowerCase() || "";

    const [activeTab, setActiveTab] = useState(t("posts"));
    const [allPosts, setAllPosts] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [filteredResults, setFilteredResults] = useState([]);

    const [hasPostResults, setHasPostResults] = useState(false);
    const [hasUserResults, setHasUserResults] = useState(false);
    const [hasGameResults, setHasGameResults] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 750);

    const navigate = useNavigate();

    const [visibleCount, setVisibleCount] = useState(10);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const token = sessionStorage.getItem("token");
    useEffect(() => {
        const handleResize = () => {
        setIsMobile(window.innerWidth < 750);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isMobile) return;
      
        const handleScroll = () => {
          if (
            !isLoadingMore &&
            window.innerHeight + document.documentElement.scrollTop >=
              document.documentElement.offsetHeight - 50 &&
            visibleCount < filteredResults.length
          ) {
            setIsLoadingMore(true);
            setTimeout(() => {
              setVisibleCount((prev) =>
                Math.min(prev + 15, filteredResults.length)
              );
              setIsLoadingMore(false);
            }, 1000);
          }
        };
      
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [filteredResults.length, isMobile, isLoadingMore, visibleCount]);
      

  

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_PATH}/posts?parentID=`, {
        headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => res.json())
        .then((result) => setAllPosts(result[0] || []));

        fetch(`${process.env.REACT_APP_API_PATH}/users`, {
        headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => res.json())
        .then((result) => setAllUsers(result[0] || []));
    }, [token]);

    useEffect(() => {
        const lowercaseQuery = query.toLowerCase();

        const postMatch = allPosts.some((post) => {
        const title = post.attributes?.title?.toLowerCase() || "";
        const body = post.content?.toLowerCase() || "";
        return title.includes(lowercaseQuery) || body.includes(lowercaseQuery);
        });
        setHasPostResults(postMatch);

        const userMatch = allUsers.some((user) => {
        const username = user.attributes?.username?.toLowerCase() || "";
        return username.includes(lowercaseQuery);
        });
        setHasUserResults(userMatch);

        const gameMatch = Object.keys(gamesData).some((name) =>
        name.toLowerCase().includes(lowercaseQuery)
        );
        setHasGameResults(gameMatch);
    }, [query, allPosts, allUsers]);

    useEffect(() => {
        if (activeTab === t("posts")) {
        const filtered = allPosts.filter((post) => {
            const title = post.attributes?.title?.toLowerCase() || "";
            const body = post.content?.toLowerCase() || "";
            return title.includes(query) || body.includes(query);
        });
        setFilteredResults(filtered);
        } 

        else if (activeTab === t("users")) {
            let isCancelled = false;
          
            const fetchUsers = () => {
              const matchedUsers = allUsers.filter((user) => {
                const username = user.attributes?.username?.toLowerCase() || "";
                return username.includes(query);
              });
          
              if (!isCancelled) {
                setFilteredResults(matchedUsers);
              }
            };
          
            fetchUsers();
          
            return () => {
              isCancelled = true;
            };
        }

        else if (activeTab === t("games")) {
            let isCancelled = false;
        
            const findMatches = () => {
            const matches = Object.entries(gamesData).filter(([name]) =>
                name.toLowerCase().includes(query)
            );
            if (!isCancelled) {
                setFilteredResults(matches);
            }
            };
        
            findMatches();
        
            return () => {
            isCancelled = true;
            };
        }
    }, [query, allPosts, allUsers, activeTab, token]);

    return (
        <div>
        {isMobile ? (
            <div className="mobile-content-wrapper">
            <div className="mobile-posts-section">
                <div className={filterStyles.sortBanner}>
                    <span className={filterStyles.sortText} title={query}>
                        {t("search_results_for")}"{query}"
                    </span>
                <div className={filterStyles.controlsContainer}>
                {[t("posts"), t("users"), t("games")].map((tab) => {
                    const tabKey = tab.toLowerCase();
                    const hasResults =
                        (tabKey === "posts" && hasPostResults) ||
                        (tabKey === "users" && hasUserResults) ||
                        (tabKey === "games" && hasGameResults);

                    return (
                        <div key={tab} className={filterStyles.tabWrapper}>
                        <button
                            className={`${filterStyles.filterBtn} ${
                            activeTab === tab ? filterStyles.activeButton : ""
                            }`}
                            onClick={() => {
                            setFilteredResults([]);
                            setActiveTab(tab);
                            }}
                        >
                            {tab}
                        </button>
                        {hasResults && <div className={filterStyles.resultDot} />}
                        </div>
                    );
                    })}
                    </div>
                </div>

                <div className="posts-container">
                    {activeTab === t("posts") && (
                        filteredResults.length > 0 ? (
                        <PostingList posts={filteredResults} type="postlist" />
                        ) : (
                        <p>{t("no_posts_found")}</p>
                        )
                    )}


                    {activeTab === t("users") && Array.isArray(filteredResults) ? (
                    filteredResults.length > 0 ? (
                        <div className={filterStyles.userResults}>
                        {filteredResults.map((user) => {
                            const favoriteGames = (user.attributes.favoriteGames || []).slice(0, 5);
                            const validGameImages = favoriteGames
                            .map((gameId) => Object.values(gamesData).find((g) => g.id === gameId))
                            .filter(Boolean);

                            return (
                            <div key={user.id} className={filterStyles.userContainer}>
                                <div className={filterStyles.userLeft}>
                                <img
                                    src={user.attributes.picture || "/defaultpfp.png"}
                                    alt="profile"
                                    className={filterStyles.profileImage}
                                />
                                <div className={filterStyles.usernameText}>
                                    {user.attributes.username}
                                </div>
                                <button
                                    className={filterStyles.viewProfileBtn}
                                    onClick={() => navigate(`/profile/${user.id}`)}
                                >
                                    {t("view_profile")}
                                </button>
                                </div>

                                {validGameImages.length > 0 && (
                                <div className={filterStyles.favoritesGamesList}>
                                    <div className={filterStyles.favoritesTitle}>{t("favorite_games")}:</div>
                                    <div className={filterStyles.gamesList}>
                                    {validGameImages.map((game, index) => (
                                        <div key={index} className={filterStyles.gameFrame}>
                                        <img
                                            src={game.carouselImage}
                                            alt={game.name}
                                            className={filterStyles.gameImage}
                                        />
                                        </div>
                                    ))}
                                    </div>
                                </div>
                                )}
                            </div>
                            );
                        })}
                        </div>
                    ) : (
                        <p>{t("no_users_found")}</p>
                    )
                    ) : null}



                    {activeTab === t("games") && filteredResults.length > 0 ? (
                    <div className={filterStyles.gameListContainer}>
                        {filteredResults.map(([name, data]) => (
                        <div key={name} className={filterStyles.gameInfo}>
                            <div className={filterStyles.gameImage}>
                            <img src={data.carouselImage} alt={name} />
                            </div>
                            <div className={filterStyles.gameDetails}>
                            <h2>{name}</h2>
                            <h4>{t("genre")}: {data.genre}</h4>
                            <p>{data.about}</p>
                            <button
                                className={filterStyles.goToPage}
                                onClick={() =>
                                navigate(`/game/${name}`, { state: { game: { name, ...data } } })
                                }
                            >
                                {t("go_to_page")}
                            </button>
                            </div>
                        </div>
                        ))}
                    </div>
                    ) : (
                    activeTab === t("games") && <p>{t("no_games_found")}</p>
                    )}


                </div>
            </div>
            <TrendingGames />
            </div>
        ) : (
            //DESKTOP BELOW
            <div className="content-wrapper">
            <div className="left-section">
                <div className={filterStyles.sortBanner}>
                    <span className={filterStyles.sortText} title={query}>
                        {t("search_results_for")}"{query}"
                    </span>
                    
                    <div className={filterStyles.controlsContainer}>
                    {[t("posts"), t("users"), t("games")].map((tab) => {
                    const tabKey = tab.toLowerCase();
                    const hasResults =
                        (tabKey === "posts" && hasPostResults) ||
                        (tabKey === "users" && hasUserResults) ||
                        (tabKey === "games" && hasGameResults);

                    return (
                        <div key={tab} className={filterStyles.tabWrapper}>
                        <button
                            className={`${filterStyles.filterBtn} ${
                            activeTab === tab ? filterStyles.activeButton : ""
                            }`}

                            onClick={() => {
                            setFilteredResults([]);
                            setActiveTab(tab);
                            }}

                        >
                            {tab}
                        </button>
                        {hasResults && <div className={filterStyles.resultDot} />}
                        </div>
                    );
                    })}
                    </div>
                </div>

                <div className="posts-container">
                    {activeTab === t("posts") && (
                        filteredResults.length > 0 ? (
                        <>
                            <PostingList
                            posts={isMobile ? filteredResults : filteredResults.slice(0, visibleCount)}
                            type="postlist"
                            />
                            {!isMobile && isLoadingMore && (
                            <div className="loading-spinner">{t("loading_more_posts")}</div>
                            )}
                        </>
                        ) : (
                        <p>{t("no_posts_found")}</p>
                        )
                    )}




                    {activeTab === t("users") && Array.isArray(filteredResults) ? (
                    filteredResults.length > 0 ? (
                        <div className={filterStyles.userResults}>
                        {filteredResults.map((user) => {
                            const favoriteGames = (user.attributes.favoriteGames || []).slice(0, 5);
                            const validGameImages = favoriteGames
                            .map((gameId) => Object.values(gamesData).find((g) => g.id === gameId))
                            .filter(Boolean);

                            return (
                            <div key={user.id} className={filterStyles.userContainer}>
                                <div className={filterStyles.userLeft}>
                                <img
                                    src={user.attributes.picture || "/defaultpfp.png"}
                                    alt="profile"
                                    className={filterStyles.profileImage}
                                />
                                <div className={filterStyles.usernameText}>
                                    {user.attributes.username}
                                </div>
                                <button
                                    className={filterStyles.viewProfileBtn}
                                    onClick={() => navigate(`/profile/${user.id}`)}
                                >
                                    {t("view_profile")}
                                </button>
                                </div>

                                {validGameImages.length > 0 && (
                                <div className={filterStyles.favoritesGamesList}>
                                    <div className={filterStyles.favoritesTitle}>{t("favorite_games")}:</div>
                                    <div className={filterStyles.gamesList}>
                                    {validGameImages.map((game, index) => (
                                        <div key={index} className={filterStyles.gameFrame}>
                                        <img
                                            src={game.carouselImage}
                                            alt={game.name}
                                            className={filterStyles.gameImage}
                                        />
                                        </div>
                                    ))}
                                    </div>
                                </div>
                                )}
                            </div>
                            );
                        })}
                        </div>
                    ) : (
                        <p>{t("no_users_found")}</p>
                    )
                    ) : null}



                    {activeTab === t("games") && filteredResults.length > 0 ? (
                    <div className={filterStyles.gameListContainer}>
                        {filteredResults.map(([name, data]) => (
                        <div key={name} className={filterStyles.gameInfo}>
                            <div className={filterStyles.gameImage}>
                            <img src={data.carouselImage} alt={name} />
                            </div>
                            <div className={filterStyles.gameDetails}>
                            <h2>{name}</h2>
                            <h4>{t("genre")}: {data.genre}</h4>
                            <p>{data.about}</p>
                            <button
                                className={filterStyles.goToPage}
                                onClick={() =>
                                navigate(`/game/${name}`, { state: { game: { name, ...data } } })
                                }
                            >
                                {t("go_to_page")}
                            </button>
                            </div>
                        </div>
                        ))}
                    </div>
                    ) : (
                    activeTab === t("games") && <p>{t("no_games_found")}</p>
                    )}

                </div>
            </div>

            <div className={styles.trendingGamesWrapper}>
                <TrendingGames />
            </div>
            </div>
        )}
        </div>
    );
};

export default FilterSearch;
